import React, { useState, useEffect, useMemo } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { format } from 'date-fns';
import RenderDays from '../day/renderDays';
import { useCalendar } from '../calendarContext';
import RenderEventListForMonth from '../month/rederEventListForMonth';
 
const MonthView = ({ monthDate, openings, showMontHeader = false, showEventDetailsInside = false, showEventDetailsOutside = false, showEventMarker = false, calculateHeight = false }) => {
    const {
        bookingDatas, 
    } = useCalendar();

    const [mHeight, setMHeight] = useState(null);

    // Calculate height only once on mount or if `calculateHeight` changes
    const updateHeight = useMemo(() => {
        if (!calculateHeight) return null;

        const windowHeight = window.innerHeight;
        const calendarHeight = windowHeight;
        return calendarHeight / 6; // Return the row height calculation
    }, [calculateHeight]); // Only update if `calculateHeight` changes

    useEffect(() => {
        if (updateHeight !== null) {
            setMHeight(updateHeight);
        }
    }, [updateHeight]);

    if (!monthDate) return null;

    return (
        <Grid container style={{ width: '100%', minWidth: '200px', flexGrow: 1,  }} >
            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Paper sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    {showMontHeader && <Typography variant="h5" marginBottom={"20px"} style={{ fontWeight: 'bold' }}>
                        {format(monthDate, 'MMMM yyyy')}
                    </Typography>
                    }

                    {/* Month Days with full event details */}
                    <Grid container>
                        {RenderDays({ month: monthDate, showEventDetailsInside, showEventMarker, mHeight, openings })}
                    </Grid>

                    {/* Render the event list for the month */}
                    <div>
                        {showEventDetailsOutside && RenderEventListForMonth(monthDate, bookingDatas)}
                    </div>
                </Paper>
            </Grid>
        </Grid>
    );
};


export default MonthView;
